module.exports = __webpack_public_path__ + "img/icon-cardgames-black.00f80005.svg";